export const RELOAD_TRANSLATIONS = 'RELOAD_TRANSLATIONS'
export const RELOAD_TRANSLATIONS_SUCCESS = 'RELOAD_TRANSLATIONS_SUCCESS'
export const RELOAD_TRANSLATIONS_FAILED = 'RELOAD_TRANSLATIONS_FAILED'
